export const fmtDateTimeDE = (iso?: string | null) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("de-DE", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
};

export const joinAddressLine = (r: any) =>
  [
    r.label,
    r.street && `${r.street} ${r.streetNumber ?? ""}`.trim(),
    r.zip && r.city ? `${r.zip} ${r.city}` : r.city,
  ]
    .filter(Boolean)
    .join(" · ");

export const gmapsQueryUrl = (r: any) => {
  const q = [
    r.street && `${r.street} ${r.streetNumber ?? ""}`.trim(),
    r.zip,
    r.city,
    r.country,
  ]
    .filter(Boolean)
    .join(" ");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
};
